export const QUEUE_STRINGS = {
  BACK: 'Back',
  CREATE_NEW_CASE: 'Create New case',
  INTAKE_QUEUE: 'Intake Queue',
  UNASSIGNED: 'Unassigned',
  ASSIGNED: 'Assigned',
  SUBMITTED: 'Submitted',
  DISCARDED: 'Discarded',
  INTAKE_ID: 'Intake Id',
  INTAKE_ID_KEY: 'intake_id',
  TYPE: 'Type',
  TYPE_KEY: 'type',
  CLIENT: 'Client',
  CLIENT_KEY: 'client',
  PROGRAM: 'Program',
  PROGRAM_KEY: 'program',
  FAX_NAME: 'Fax Name',
  FAX_NAME_KEY: 'fax_name',
  DATE_AND_TIME: 'Date/Time',
  DATE_AND_TIME_KEY: 'date_time',
  SENT_BY: 'Sent By',
  SENT_BY_KEY: 'sent_by',
  ASSIGNED_TO: 'Assigned To',
  ASSIGNED_TO_KEY: 'assigned_to',
  ACTIONS: 'Actions',
  ACTIONS_KEY: 'actions',
  ASSIGN_TO_ME: 'Assign to me',
  REVIEW: 'Review',
  FAX_REVIEW: 'Fax Review',
  WEB_INTAKE_REVIEW: 'Web Intake Review',
  HYPERLINK: 'hyperlink',
  ENROLLMENT_ID: 'enrollment_id',
  COMMUNICATION_ID: 'communication_id',
  DISCARD: 'Discard',
  SUBMIT: 'Submit',
  CASE_OVER: 'Case Overview',
  CASE_STATUS_ADMINISTRATIVE_INFO: 'Case Status and Administrative Information',
  ASSOCIATED_HEALTHCARE_FACILITY: 'Associated Healthcare Facility',
  ENROLLMENT_INF_OF_PATIENT: 'Enrollment Information of Patient',
  CASE_LAYOUT: 'Case Layout',
  NO_RECORD_PRESENT: 'No Record Present',
  DOWNLOAD: 'Download',
  SELECT_CASE: 'Select Case',
  ATTACH: 'Attach',
  ATTACH_TOOLTIP: 'Please select a case to enable the attach button.',
  CASE_ID: 'Case ID',
  AGING: 'Aging',
  HIGH: 'High',
  CASE_TYPE: 'Case Type',
  AGENT_ID: 'Agent ID',
  DATE_SUBMITTED: 'Date Submitted',
  DOCUMENT_NAME: 'Document Name',
  ATTENDING_PHYSICIAN: 'Attending Physician',
  FACILITY_CLINIC_NAME: 'Facility/Clinic Name',
  CURRENT_CASE_STATUS: 'Current Case Status',
  PRIORITY_LEVEL: 'Priority Level',
  CONFIRM_ATTACHMENT_MESSAGE:
    'Are you sure you want to attach this document to the case?',
  CONFIRM_REASON_LABEL: 'If yes, please put the reason here',
  WORDS_50: '50 Words',
  CANCEL: 'Cancel',
  CREATE_CASE: 'Create Case',
  FAX_DISCARDED: 'Fax Discarded',
  MAIL_DISCARDED: 'Mail Discarded',
  ERROR_DISCARDING_FAX: 'Error discarding Fax',
  CASE_ATTACHED: 'Document Attached Successfully!',
  ERROR_DISCARDING_CASE: 'Error Attaching Document',
  REASON_REQUIRED: 'Reason is required',
  REASON_LIMIT: 'Reason cannot exceed 50 words',
  SUCCESS: 'SUCCESS',
  CHANGE_CLIENT_MESSAGE:
    'Changing the client will redirect you to dashboard. Are you sure you want to proceed?',
  COMMUNICATIONS_LOWERCASE: 'communications',
  COMMUNICATION_LOWERCASE: 'communication',
  EDIT_MODE: 'EDIT_MODE',
  COMPLETED: 'COMPLETED',
  EMAIL_REVIEW: 'Email Review',
  DOCUMENT_PREVIEW: 'Document Preview',
  SPLIT_MAIL: 'Split Mail',
  SPLIT_FAX: 'Split Fax',
  FAX: 'FAX',
  WEB: 'WEB',
  DOCUMENT_TYPE: 'DOCUMENT',
  EMAIL: 'EMAIL',
  MAIL: 'Mail',
  SPLIT_DOCUMENT_INTO: 'Split the Document into',
  SPLIT_DOCUMENT_SUCCESS: 'Document split successfully',
  SPLIT_FAX_SUCCESS: 'Fax split successfully',
  SPLIT_DOCUMENT_ERROR: 'Error splitting Document',
  CASE_ID_KEY: 'case_key',
  TASK_CASE_ID: 'case_id',
  TASK_ID: 'task_id',
  TASK_CODE: 'task_code',
  CLICK_WITH_SPACES: ' - Click ',
  HERE: 'here',
  TO_REVIEW_AND_UPDATE: ' to review and update',
  PROCESSING: 'PROCESSING',
  HCP_PORTAL_ENTITY_LOWERCASE: 'hcp_portal_entity',
  INTAKE_DISCARDED: 'Intake Discarded successfully',
  ERROR_DISCARDING_INTAKE: 'Error discarding Intake',
  CASE_LOWERCASE: 'case',
  CASES_KEY: 'cases',
  PRINT: 'Print',
  MARK_AS_COMPLETE: 'Mark as Completed',
  PAGES: 'Pages',
  RANGE: 'Range',
  EG_1_2_3: 'e.g.:1,2,3',
  EG_1_3: 'e.g.:1-3',
  AE_PC_DOCUMENT: 'ae_pc_document',
  DISCARD_BUTTON_TOOLTIP: 'You do not have permission to discard intakes.',
  INTAKE: 'Intake',
  HAS_MULTI_PRODUCT: 'hasMultiProduct',
  TRUE_STRING: 'true',
  IS_MULTI_PRODUCT_ENABLED: 'isMultiProductEnabled',
}
export const CASE_OVERVIEW_STRINGS = {
  CASE_NAME: 'Case Name',
  CASE_Status: 'Case_Status',
  CASE_Type: 'Case_Type',
  CLOSE_DATE: 'Close Date',
  OPEN_DATE: 'Open Date',
  CANCEL_REQUESTED_BY: 'Cancel Requested By',
  CANCEL_REASON: 'Cancel Reason',
}
export const CASE_STATUS_ADMINISTRATIVE_INFO_STRINGS = {
  CASE_STATUS_MODIFIED_DATE: 'CaseStatusModifiedDate',
  OTHER_CASE_STATE: 'OtherCaseState',
  CLOSED_BY: 'ClosedBy',
  CASE_STATE_MODIFIED_DATE: 'CaseStateModifiedDate',
  CASE_REFERENCE: 'CaseReference',
}
export const ASSOCIATED_HEALTHCARE_FACILITY = {
  FACILITY: 'Facility',
}
export const ENROLLMENT_INF_OF_PATIENT_STRINGS = {
  ASSOCIATED_PATIENT: 'Associated Patient',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  ENROLLMENT_DATE: 'Enrollment Date',
  CONTACT: 'Contact',
  CONTACT_FIRST_NAME: 'Contact First Name',
}
export interface ReviewQueueProps {
  caseName: string
  case_status: string[]
  case_type: string[]
  close_date: string
  open_date: string
  cancel_requested: string
  cancel_reason: string
  case_modified: string
  other_case: string
  closed_by: string[]
  case_state: string[]
  case_reference: string
  facility: string
  patient: string
  first_name: string
  last_name: string
  enrollment_date: string
  contact: string
  contact_first_name: string
}
